import Document from "documents/entities/document/document";
import _ from "lodash";

export default class UpdateDocumentAPIRequest {
  payload: Array<{ op: string, path: string, value: unknown }> = [];

  constructor(originalDocument: Document, updatedDocument: Document) {
    if (originalDocument.id.value !== updatedDocument.id.value) {
      throw new Error("Document Id cannot be changed");
    }
    if (originalDocument.creatorId?.value !== updatedDocument.creatorId?.value) {
      throw new Error("Creator Id cannot be changed");
    }
    if (originalDocument.fileType !== updatedDocument.fileType) {
      throw new Error("Document Type cannot be changed");
    }
    if (originalDocument.created !== updatedDocument.created) {
      throw new Error("Created Date cannot be changed");
    }


    if (updatedDocument.name?.value !== originalDocument.name?.value) {
      this.payload = [{ op: "replace", path: "/name", value: updatedDocument.name?.value ?? null }];
    }
    if (!_.isEqual(updatedDocument.readAccess, originalDocument.readAccess)) {
      this.payload.push({ op: "replace", path: "/readAccess", value: updatedDocument.readAccess });
    }
    if (!_.isEqual(updatedDocument.writeAccess, originalDocument.writeAccess)) {
      this.payload.push({ op: "replace", path: "/writeAccess", value: updatedDocument.writeAccess });
    }
    if (!_.isEqual(updatedDocument.topics, originalDocument.topics)) {
      this.payload.push({ op: "replace", path: "/topics", value: updatedDocument.topics });
    }
  }
}
